<script setup>
// Shared body of every confirmation-style modal: artwork on top, centered title,
// optional explanation, optional extra controls, then a two-button row. Rendered by
// ConfirmActionDialog (delete & friends) and by ActionResponse (согласование, отказ,
// доработка, отзыв, подписание) so the two cannot drift apart.
//
// The artwork box is a fixed square for every action — a per-modal icon size was the
// main reason the dialogs looked unrelated. Keep the size on the tailwind.config.js
// scale (there is no `30`/`17`): an off-scale class is silently dropped and the image
// falls back to its intrinsic size, which is exactly how a glyph-sized sign.svg ended
// up next to a full-size confirm-delete.svg.
defineProps({
    title: { type: String, required: true },
    // Explanation under the title. Use it to clarify a required field or the
    // consequence — not to restate the title.
    desc: { type: String, default: "" },
    // Path to the artwork image; override the `artwork` slot for anything richer.
    icon: { type: String, default: "" },
});
</script>

<template>
    <div class="flex flex-col items-center gap-5 text-center">
        <slot name="artwork">
            <img
                v-if="icon"
                :src="icon"
                class="w-32 h-32"
                alt="" />
        </slot>

        <h4 class="text-lg font-semibold px-8">{{ title }}</h4>
        <p
            v-if="desc"
            class="text-sm text-dark-light">
            {{ desc }}
        </p>

        <!-- Action-specific controls (comment box, certificate picker, …). -->
        <slot name="fields" />

        <div class="grid grid-cols-2 w-full gap-5">
            <slot name="buttons" />
        </div>
    </div>
</template>
